export default __webpack_public_path__ + "static/media/1283.57841feb.png";